export const SUBSCRIPTION_PRICING_INFORMATION = [
    {
        title: 'Pay per use',
        price: '$30.00',
        priceQuantity: ' / Course',
        courses: '1',
        uploadQuota: 'NA',
        maxPackageSize: '256 MB',
        mediaHours: '0.5',
        costPerCourse: '$30.00',
        info: ['Pay as you go', 'Priority support'],
        buttonText: 'Activate Plan',
    },
    {
        title: 'Starter',
        price: '$4,990',
        priceQuantity: ' / 3 months',
        courses: '250',
        uploadQuota: '50 GB',
        maxPackageSize: '512 MB',
        mediaHours: '250',
        costPerCourse: '$19.96',
        info: ['3 months access', 'Priority support'],
        buttonText: 'Activate Plan',
    },
    {
        title: 'Pro',
        price: '$11,990',
        priceQuantity: ' / 1 year',
        courses: '1000',
        uploadQuota: '1 TB',
        maxPackageSize: '1 GB',
        mediaHours: '1000',
        costPerCourse: '$11.99',
        info: ['Full year access', 'API access', 'Priority support'],
        buttonText: 'Activate Plan',
    },
    {
        title: 'Enterprise',
        price: 'Customised',
        priceQuantity: ' plan',
        courses: 'custom',
        uploadQuota: 'custom',
        maxPackageSize: 'custom',
        mediaHours: 'custom',
        costPerCourse: 'NA',
        info: ['Self-hosted option', 'API access', 'Dedicated support'],
        buttonText: 'Request Information',
    },
];

export const CLOUD_STORAGE_TYPE = [
    { name: 'Azure Blob Storage', label: 'Azure', type: 'azure' },
    { name: 'Google Cloud Storage', label: 'GCS', type: 'gcs' },
    { name: 'AWS S3 Bucket', label: 'S3', type: 's3' },
];

export const EXCLUDED_EMAIL_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'msn.com',
    'zoho.com',
    'proton.com',
    'protonmail.com',
    'icloud.com',
    'live.com',
    'aol.com',
];